/*
 * wim-analytics-leads.js
 *
 * Instrumenta el funnel profesional: clic en contactar, apertura del formulario,
 * inicio de cumplimentación y envío, en las dos variantes que sirve el tema.
 *
 *   crm_iframe    → formulario del CRM embebido (mercado local)
 *   shopify_forms → bloque de Shopify Forms (resto de mercados y página de contacto)
 *
 * Los dos bloques de constantes de configuración de arriba son los únicos
 * valores que deben ajustarse tras la verificación en la tienda real.
 */

(function () {
  'use strict';

  var INIT_FLAG = 'wimAnalyticsLeadsInit';
  if (window[INIT_FLAG]) return;
  window[INIT_FLAG] = true;

  /* ── Configuración ────────────────────────────────────────────────────── */

  /* Orígenes admitidos para los mensajes del formulario embebido. Cualquier
     mensaje de otro origen se descarta sin procesar. */
  var CRM_ORIGINS = ['https://link.marketlabs.es'];

  /* Decide si un mensaje recibido representa un envío completado.
     Ajustado para Marketlabs: envía 'set-sticky-contacts' al crear el lead. */
  function isCrmSubmitMessage(data) {
    if (!data) return false;
    var text = typeof data === 'string' ? data : JSON.stringify(data);
    return /form[_-]?submit|submitted|formSubmitted|set-sticky-contacts/i.test(text);
  }

  /* Selectores que identifican el estado de éxito de Shopify Forms dentro de su
     contenedor. PENDIENTE DE VERIFICAR: confirmar el marcado real de la app. */
  var FORMS_SUCCESS_SELECTORS = [
    '[data-form-success]',
    '[data-success-message]',
    '[class*="success"]'
  ];

  /* Nombre del parámetro y del campo que transportan el origen del lead */
  var ORIGIN_KEY = 'wim_origin';


  /* ── Utilidades ───────────────────────────────────────────────────────── */

  var dl = (window.dataLayer = window.dataLayer || []);

  function context() {
    return window.wimAnalyticsContext || {};
  }

  /* Los eventos propios se publican con prefijo para no colisionar con los
     que emite el canal de Google. El nombre estándar se aplica en la etiqueta,
     al enviar a la analítica. El objeto de comercio electrónico se limpia antes
     de cada envío para que no arrastre valores del mensaje anterior. */
  function push(name, payload) {
    dl.push({ ecommerce: null });
    dl.push(Object.assign({ event: 'wim_' + name, wim_source: 'theme' }, context(), payload || {}));
  }

  /* Un elemento se considera visible si el CSS no lo ha retirado del flujo.
     La visibilidad por marca y región del tema se resuelve con display:none. */
  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  /* Valor de origen del lead: identificadores técnicos, sin datos personales */
  var ORIGIN_VALUE = (function () {
    var c = context();
    var handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    return [
      c.page_template || 'unknown',
      c.segment || 'unknown',
      handle,
      c.content_locale || '',
      c.geo_region || ''
    ].join('|').replace(/[^\w|.\-]/g, '');
  })();

  window.wimAnalyticsLeads = { origin: ORIGIN_VALUE };

  /* ── Propagación del origen ───────────────────────────────────────────── */

  /* Añade el origen a la URL del iframe del CRM. Se hace una sola vez y en la
     carga inicial, para no recargar el iframe al abrir el diálogo. */
  function tagCrmIframes() {
    var frames = document.querySelectorAll('iframe[src*="' + CRM_ORIGINS[0].replace(/^https?:\/\//, '') + '"]');
    Array.prototype.forEach.call(frames, function (frame) {
      var src = frame.getAttribute('src') || '';
      if (!src || src.indexOf(ORIGIN_KEY + '=') !== -1) return;
      frame.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') +
        ORIGIN_KEY + '=' + encodeURIComponent(ORIGIN_VALUE));
    });
  }

  /* Inserta el origen como campo oculto en los formularios de Shopify Forms.
     Solo surte efecto si la app serializa el formulario del DOM al enviar. */
  function tagShopifyForms(scope) {
    var forms = scope.querySelectorAll('form');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.querySelector('input[name="' + ORIGIN_KEY + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = ORIGIN_KEY;
      input.value = ORIGIN_VALUE;
      form.appendChild(input);
    });
  }

  /* ── Clic en el disparador de contacto ────────────────────────────────── */

  var TRIGGER_SELECTOR = '[data-wim-contact-open], a[href$="#wim-contact-open"]';
  var lastClickAt = 0;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    /* Guarda de idempotencia: la barra fija y el botón de la ficha pueden
       resolver al mismo clic lógico. */
    var now = Date.now();
    if (now - lastClickAt < 500) return;
    lastClickAt = now;

    push('cta_contact_click', {
      cta_location: trigger.getAttribute('data-wim-cta-location') ||
        (trigger.closest('.wim-cta--pdp') || trigger.matches('.wim-cta--pdp') ? 'pdp' : 'other'),
      lead_origin: ORIGIN_VALUE
    });
  }, true);

  /* ── Ámbitos de formulario ────────────────────────────────────────────── */

  /*
   * Un ámbito es un contenedor que aloja un formulario medible. Se registran
   * tanto el diálogo de contacto como los formularios en línea de las páginas.
   */
  var seen = { start: {}, lead: {} };

  function variantOf(scope) {
    if (scope.querySelector('iframe[src*="' + CRM_ORIGINS[0].replace(/^https?:\/\//, '') + '"]')) {
      return 'crm_iframe';
    }
    return 'shopify_forms';
  }

  function scopeId(scope) {
    return scope.getAttribute('id') || scope.getAttribute('data-section-id') || 'scope';
  }

  function reportView(scope) {
    push('form_view', {
      form_variant: variantOf(scope),
      form_scope: scopeId(scope),
      lead_origin: ORIGIN_VALUE
    });
  }

  function reportStart(scope) {
    var key = scopeId(scope);
    if (seen.start[key]) return;
    seen.start[key] = true;
    push('form_start', {
      form_variant: variantOf(scope),
      form_scope: key,
      lead_origin: ORIGIN_VALUE
    });
  }

  function reportLead(scope, variant) {
    var key = scopeId(scope) + ':' + variant;
    if (seen.lead[key]) return;
    seen.lead[key] = true;
    push('generate_lead', {
      form_variant: variant,
      form_scope: scopeId(scope),
      lead_origin: ORIGIN_VALUE
    });
  }

  /* El inicio solo es observable en la variante de Shopify Forms: el contenido
     del iframe del CRM es inaccesible desde la página contenedora. */
  function watchStart(scope) {
    scope.addEventListener('focusin', function () { reportStart(scope); });
    scope.addEventListener('input', function () { reportStart(scope); });
  }

  /* Vigila la aparición del estado de éxito dentro del contenedor, mientras el
     formulario está en pantalla. Se desconecta al confirmar o al ocultarse. */
  function watchSuccess(scope) {
    if (scope.__wimWatching) return;
    scope.__wimWatching = true;

    var interval = setInterval(function () {
      var hit = false;
      
      // 1. Buscar en el DOM normal
      hit = FORMS_SUCCESS_SELECTORS.some(function (selector) {
        var node = scope.querySelector(selector);
        return node && isVisible(node);
      });

      // 2. Buscar dentro del Shadow DOM de Shopify Forms
      if (!hit) {
        var embed = scope.querySelector('shopify-forms-embed');
        if (embed && embed.shadowRoot) {
          var text = embed.shadowRoot.textContent || "";
          if (text.indexOf('Success') !== -1 || text.indexOf('Thank you') !== -1 || text.indexOf('submitted') !== -1) {
            hit = true;
          }
        }
      }

      if (hit) {
        clearInterval(interval);
        scope.__wimWatching = false;
        reportLead(scope, 'shopify_forms');
      }
    }, 1000);

    // Timeout de seguridad de 10 minutos
    setTimeout(function () {
      clearInterval(interval);
      scope.__wimWatching = false;
    }, 600000);
  }

  function registerScope(scope) {
    if (!scope || scope.__wimRegistered) return;
    scope.__wimRegistered = true;
    tagShopifyForms(scope);
    watchStart(scope);
    watchSuccess(scope);
  }

  /* ── Diálogo de contacto ──────────────────────────────────────────────── */

  function watchPopup() {
    var popup = document.querySelector('[data-wim-contact-popup]');
    if (!popup) return;

    var dialog = popup.querySelector('dialog');
    if (!dialog || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      if (!dialog.hasAttribute('open')) return;
      registerScope(popup);
      reportView(popup);
    });

    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── Puerta de acceso al área profesional ─────────────────────────────── */

  /*
   * La decisión del usuario ya la publica el propio tema con el evento
   * popup_brand_gate_decision, que el contenedor consume directamente. Aquí solo
   * se añade la apertura de la puerta, que no emite nada, para poder calcular la
   * tasa de acceso al área profesional.
   */
  function watchBrandGate() {
    var gate = document.querySelector('wim-popup-toskanimed');
    if (!gate) return;

    var dialog = gate.querySelector('dialog');
    if (!dialog || !window.MutationObserver) return;

    var reported = false;

    function report() {
      if (reported || !dialog.hasAttribute('open')) return;
      reported = true;
      push('brand_gate_view', { gate_source: context().page_template || '' });
    }

    report();

    var observer = new MutationObserver(report);
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── Formularios en línea ─────────────────────────────────────────────── */

  function watchInlineForms() {
    var sections = document.querySelectorAll('.wim-contact-form');
    Array.prototype.forEach.call(sections, function (section) {
      if (!isVisible(section)) return;
      registerScope(section);

      if (!window.IntersectionObserver) {
        reportView(section);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          reportView(section);
        });
      }, { threshold: 0.5 });
      io.observe(section);
    });
  }

  /* ── Mensajes del formulario embebido ─────────────────────────────────── */

  window.addEventListener('message', function (event) {
    if (CRM_ORIGINS.indexOf(event.origin) === -1) return;
    if (!isCrmSubmitMessage(event.data)) return;

    var popup = document.querySelector('[data-wim-contact-popup]') || document.body;
    reportLead(popup, 'crm_iframe');
  });

  /* ── Arranque ─────────────────────────────────────────────────────────── */

  function init() {
    tagCrmIframes();
    watchPopup();
    watchBrandGate();
    watchInlineForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
